/**
 * Which primary navigation item a location belongs to — the matching
 * NavLink used to do before the rail moved to generic-components'
 * VerticalNavigation, which is router-agnostic and takes the active id
 * from the caller.
 */
export interface NavRoute {
  to: string;
  /** Match the route exactly (used for the index "/" route). */
  end?: boolean;
}

/**
 * The `to` of the item `pathname` falls under, or `undefined` off every
 * section. An `end` item matches only its own path; any other matches its
 * own path and every child path under it, segment-wise — `/pipelines/x`
 * belongs to `/pipelines`, `/pipelines-archive` does not. Query and hash
 * are not part of the decision.
 */
export function activeNavTo<T extends NavRoute>(
  pathname: string,
  items: readonly T[],
): T["to"] | undefined {
  const path = pathname.split(/[?#]/, 1)[0];
  return items.find((item) =>
    item.end
      ? path === item.to
      : path === item.to || path.startsWith(`${item.to}/`),
  )?.to;
}
